export default "__VITE_ASSET__267b6f90__"